import { render, staticRenderFns } from "./ProgramsHeader.vue?vue&type=template&id=273dd7b7&scoped=true&"
import script from "./ProgramsHeader.vue?vue&type=script&lang=js&"
export * from "./ProgramsHeader.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsHeader.vue?vue&type=style&index=0&id=273dd7b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273dd7b7",
  null
  
)

export default component.exports